export default {
  phoneFull: '818-902-1400',
  phone: '8189021400',
  email: 'jacques@Jbmarble.com',
  yelp: 'https://www.yelp.com/biz/jb-marble-company-los-angeles',
  googleUrl:
    'https://www.google.com/maps/place/J+B+Marble+Co/@34.210104,-118.4548688,17z/data=!4m5!3m4!1s0x80c297300ae549ad:0x5404717d200f8408!8m2!3d34.210104!4d-118.4526801',
};
